import Imgix from 'react-imgix';
import { IListItem, ListProductReferrer } from '../../list-page/interfaces/interfaces';
import { sendGAListPageEvent } from '../../../domain/marketing/gtm-provider';
import { CSSProperties } from 'react';
import ProductWishlist from '../product-wishlist/product-wishlist';
import { getABTest } from '../../../domain/abtest/abtest-provider';

interface IProductImageProps {
    product: IListItem,
    removeImgLink?: boolean,
    style?: CSSProperties,
    classes?: string,
    listName?: string,
    imageHeight?: string,
    disableImageLazy?: boolean;
    referrer?: ListProductReferrer;
}

const IMG_SMALL_SIZE = 150;
const IMG_BIG_SIZE = 200;

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-5317
 */
const getImageSize = (referrer?: ListProductReferrer) : number => {
    const abtest = getABTest('ListThumbSize');

    if(!abtest?.isActive ||
        referrer !== ListProductReferrer.ListPage) return IMG_SMALL_SIZE;

    return abtest.selected === 'big' ? IMG_BIG_SIZE : IMG_SMALL_SIZE;
};

/**
 * Product image.
 * https://docs.imgix.com/libraries/react-imgix#lazy-loading
 */
const ProductImage = (props: IProductImageProps) => {

    const product = props.product;

    /*auto height (defaulr = 150)*/
    let height : any = 150;
    let autoHeightCss = 'px-4 bg-gray-100';

    if(props?.imageHeight) {
        autoHeightCss = '';

        if(props?.imageHeight === 'auto')
            height = undefined
        else
            height = props?.imageHeight;
    }
    else{
        height =  getImageSize(props.referrer);
    }

    const getImage = () => {
        return (
            product.thumb ?
                <Imgix
                    src={ product.thumb }
                    height={ height }
                    htmlAttributes={{
                        alt: `Image for ${ product.documentName }`,
                        loading: props.disableImageLazy ? undefined : 'lazy',
                    }}
                    disableQualityByDPR
                /> : <div />
        )
    };

    /*const getImage = () => {
        return (
            product.thumb ?
            <Imgix
                className="lazyload"
                src={ product.thumb }
                height={ height }
                attributeConfig={{
                    src: 'data-src',
                    srcSet: 'data-srcset',
                    sizes: 'data-sizes',
                }}
                htmlAttributes={{
                    alt: `Image for ${ product.documentName }`
                }}
                disableQualityByDPR
            /> : <div />
        )
    };
*/
    const getBadge = () => {
        return <div className={ `text-sm text-center text-white absolute px-4 py-1 left-0 bottom-0 ${ product.badgeClass }` }>{ product.badgeText }</div>    ;
    };

    const onClick = () => {
        sendGAListPageEvent(product, props.listName);
    };

    return (
        <>
            {
                props.removeImgLink && (
                    <div
                        data-type="product-image"
                        className={`${autoHeightCss} flex justify-center items-center relative ${ props.classes }`}
                        title={ product.documentName }
                        style={ props.style }>
                        { getImage() }
                        { product.badgeText && getBadge() }
                    </div>
                )
            }

            {
                !props.removeImgLink &&
                <div>
                    <a
                        data-type="product-image"
                        href={product.documentUrlPath}
                        className={`${autoHeightCss} flex justify-center items-center relative ${props.classes}`}
                        title={product.documentName}
                        style={props.style}
                        onClick={onClick}>
                        {getImage()}
                        {product.badgeText && getBadge()}
                    </a>
                </div>
            }

            { product.isWishlist && <ProductWishlist skuid={ product.skuid } /> }
        </>
    )
};

export default ProductImage;
